<div class="text-info mb-3" *ngIf="!agentId && isAdmin">
  {{'CHOOSE_AN_AGENT_FIRST_TO_DISPLAY_INFORMATION'|translate}}
</div>

<div [hidden]="!agentId" class="">
  <ng-content></ng-content>
</div>
